/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-is-valid jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';

import './Notifier.scss';

/**
 * @description Notifier
 *
 * @param {object} props - Component props
 *
 * @returns {<Notifier />}
 */
const Notifier = props => {
  /*
  const { text, link } = props.content;

  return (
    <button
      className={`notifier ${props.hidden ? 'notifier--hidden' : ''}`}
      onClick={props.handleOpenClick}
    >
      <p className="notifier-message">
        {text}{' '}
        <a className="tds-link" href="#" onClick={props.handleOpenClick}>
          {link}
        </a>
      </p>
    </button>
  );
*/

  const { text, link, label } = props.content;

  return (
    <div className={`notifier ${props.hidden ? 'notifier--hidden' : ''}`}>
      <p className="notifier-message">
        {link && label ? (
          <a className="notifier-link" href={link} target="_blank" rel="noopener noreferrer">
            {label}
          </a>
        ) : (
          text
        )}
      </p>
    </div>
  );
};

Notifier.defaultProps = {
  content: {},
};

Notifier.propTypes = {
  content: PropTypes.objectOf(PropTypes.string),
  // handleOpenClick: PropTypes.func.isRequired,
  hidden: PropTypes.bool.isRequired,
};

export default Notifier;
